import { Injectable, Inject } from 'ng-metadata/core';
import {HttpService} from '../../../../infra/httpRequest/http.service';
import {getInstitutionCode, getInstitutionId} from '../../../../appConfig/appConfigForward';
import { HighlightService } from '../../../../infra/highlight.service';
import { NgrsService } from '../ngrs.service';
import {mmsIdOfferOutputMap, morePolicies} from "../BestOffer.interface";

const get= require('lodash/get');



@Injectable()
export class PhysicalDeliveryMoreOptionRowService {
    private ilsService: object = {};
    private moreOptionBaseUrl: any;

    constructor(private httpService: HttpService,
                private ngrsService: NgrsService,
                @Inject('restBaseURLs') private restBaseURLs) {
        this.moreOptionBaseUrl = restBaseURLs.moreOptionBaseUrl;
        this.ilsService = {
            '/bestoffer/moreResult': {
                'path': this.moreOptionBaseUrl,
                'method': 'GET'
            }
        };

    }
    public getMoreOption(policy:morePolicies){
        let params = {
            mmsid: '',
            institutionId: policy.institutionId,
            institutionCode:policy.institutionCode,
            customerId:policy.customerId,
            memberId:policy.memberId,
            policyId:policy.policyId,
            centralPolicyId:policy.centralPolicyId,
            institutionDataCenter:policy.institutionDataCenter,
            supplyTime:policy.supplyTime,
            policyType:policy.policyType,
            loanPeriod:policy.loanPeriod,
            cost:policy.cost,
            currency:policy.currency,
            allowRenewal:policy.allowRenewal,
            supportRush:policy.supportRush,
            czMemberName:policy.czMemberName,
            matchingMmsIds:policy.matchingMmsIds
        };
        return this.makeIlsRequest('/bestoffer/moreResult',params);
    }

    makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }

        let ngrsService = this.ilsService[serviceName];

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            )
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalDeliveryMoreOptionRow/physicalDeliveryMoreOptionRow.service.ts